<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="height-100px m-0 background-primary-blue w-100 border-bottom border-dark-subtle p-3 z-max d-flex justify-content-center align-items-center flex-none">
        <div (click)="routingService.back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl p-3"></i>
        </div>
        <div class="col-8">
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-auto fs-main text-center color-white">Animal ping schedule</div>
            </div>
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div class="mb-3">
            <div class="input-group position-relative">
                <input (input)="filterResults($event)"
                        class="form-control m-auto rounded-pill height-50px ps-3 pe-3"
                        placeholder="Search..."
                        style="padding-right: 30px;"
                        type="search">
                <i class="fa-solid fa-magnifying-glass"
                    style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none;"></i>
            </div>
        </div>
        <app-scheduled-animals
            [animals]="zeroToFiveMinutes()"
            title="Scheduled to ping within 5 minutes"
            icon="stopwatch-five.svg"/>
        <app-scheduled-animals
            [animals]="fiveToTenMinutes()"
            title="Scheduled to ping within 5 to 10 minutes"
            icon="stopwatch-ten.svg"/>
        <app-scheduled-animals
            [animals]="tenToFifteenMinutes()"
            title="Scheduled to ping within 10 to 15 minutes"
            icon="stopwatch-fifteen.svg"/>
        <app-scheduled-animals
            [animals]="fifteenToTwentyMinutes()"
            title="Scheduled to ping within 15 to 20 minutes"
            icon="stopwatch-twenty.svg"/>
        <app-scheduled-animals
            [animals]="twentyToTwentyFiveMinutes()"
            title="Scheduled to ping within 20 to 25 minutes"
            icon="stopwatch-twenty-five.svg"/>
        <app-scheduled-animals
            [animals]="twentyFiveToThirtyMinutes()"
            title="Scheduled to ping within 25 to 30 minutes"
            icon="stopwatch-thirty.svg"/>
        <app-scheduled-animals
            [animals]="moreThanThirtyMinutes()"
            title="Scheduled to ping after 30 minutes"
            icon="stopwatch-thirty-plus.svg"/>
        <app-scheduled-animals
            [animals]="outOfSchedule()"
            title="Out of schedule"
            icon="stopwatch-unknown.svg"/>
    </div>
</div>
